<div class="media-panel">
  <div class="header" [ngStyle]="{top: headerStickyTop + 'px'}">
    <a href="javascript:;"
       class="mobile-filters-btn"
       (click)="showMobileFilters()"
    ><mtg-svg-icon icon="icons-settings"></mtg-svg-icon> Фильтры</a>
    <div class="filters" [formGroup]="form">
      <mtg-dropdown
        *ngIf="tournaments"
        label="Турнир"
        formControlName="tournament"
        variant="button"
        [errorVisible]="false"
      >
        <mtg-dropdown-item
          *ngFor="let item of tournaments"
          [value]="item"
        >{{ item.name }}</mtg-dropdown-item>
      </mtg-dropdown>
      <mtg-dropdown
        *ngIf="selectedTournament && selectedTournament.settings.type !== tournamentTypes.fiba"
        [label]="sport.isRugby() ? 'Неделя' : 'Тур'"
        formControlName="tournamentTour"
        variant="button"
        [errorVisible]="false"
      >
        <mtg-dropdown-group title="Групповой этап">
          <mtg-dropdown-item
            *ngFor="let tour of toursOptions"
            [value]="tour.value"
          >{{ tour.title }}</mtg-dropdown-item>
        </mtg-dropdown-group>
        <mtg-dropdown-group *ngFor="let playoff of playoffs" [title]="playoff.name">
          <mtg-dropdown-item
            *ngFor="let stage of playoff.getPlayoffStages()"
            [value]="{playoffStage: stage.value, playoffId: playoff.id}"
          >{{ stage.title }}</mtg-dropdown-item>
        </mtg-dropdown-group>
      </mtg-dropdown>

      <mtg-dropdown
        *ngIf="selectedTournament && selectedTournament.settings.type === tournamentTypes.fiba"
        label="Этап"
        formControlName="tournamentStageId"
        variant="button"
        [errorVisible]="false"
      >
        <mtg-dropdown-item
          [value]="stage.id"
          *ngFor="let stage of stages"
        >{{ stage.name }}</mtg-dropdown-item>
      </mtg-dropdown>

      <mtg-dropdown
        *ngIf="selectedTournament"
        label="Команда"
        formControlName="teamId"
        variant="button"
        [errorVisible]="false"
      >
        <mtg-dropdown-item
          *ngFor="let team of teams"
          [value]="team.team.id"
        >{{ team.team.name }}</mtg-dropdown-item>
      </mtg-dropdown>
    </div>
    <div class="actions">
      <ng-container *ngIf="!selectEnabled">
        <mtg-button color="secondary" (click)="enableSelectMode()">Выбрать</mtg-button>
      </ng-container>

      <ng-container *ngIf="selectEnabled">
        <a href="javascript:;" (click)="download()"><mtg-svg-icon icon="icons-cloud-download"></mtg-svg-icon></a>
        <mtg-button color="secondary" (click)="disableSelectMode()" class="cancel-link">
          Отменить <mtg-svg-icon icon="icons-close-circle"></mtg-svg-icon>
        </mtg-button>
      </ng-container>
    </div>
  </div>

  <div class="media-games" (mtgPaginationScroll)="loadNextPage()">
    <mtg-game-media
      *ngFor="let game of games; trackBy: trackById"
      [game]="game"
      [mediaRoute]="mediaRoute"
    ></mtg-game-media>
    <mtg-spinner *ngIf="loading"></mtg-spinner>
  </div>
</div>

<div class="mobile-filters" [ngClass]="{visible: mobileFiltersVisible}">
  <div class="filters-content">
    <div class="title">
      <mtg-svg-icon icon="icons-settings"></mtg-svg-icon>
      Фильтры

      <a href="javascript:;" class="close" (click)="closeMobileFilters()">
        <mtg-svg-icon icon="icons-close"></mtg-svg-icon>
      </a>
    </div>
    <div class="content" [formGroup]="form">
      <mtg-dropdown
        *ngIf="tournaments"
        label="Турнир"
        formControlName="tournament"
        [errorVisible]="false"
      >
        <mtg-dropdown-item
          *ngFor="let item of tournaments"
          [value]="item"
        >{{ item.name }}</mtg-dropdown-item>
      </mtg-dropdown>
      <mtg-dropdown
        *ngIf="selectedTournament && selectedTournament.settings.type !== tournamentTypes.fiba"
        [label]="sport.isRugby() ? 'Неделя' : 'Тур'"
        formControlName="tournamentTour"
        [errorVisible]="false"
      >
        <mtg-dropdown-item [value]="null">Все</mtg-dropdown-item>
        <mtg-dropdown-group title="Групповой этап">
          <mtg-dropdown-item
            *ngFor="let tour of toursOptions"
            [value]="tour.value"
          >{{ tour.title }}</mtg-dropdown-item>
        </mtg-dropdown-group>
        <mtg-dropdown-group *ngFor="let group of playoffOptions" [title]="group.title">
          <mtg-dropdown-item
            *ngFor="let stage of group.stages"
            [value]="stage.value"
          >{{ stage.title }}</mtg-dropdown-item>
        </mtg-dropdown-group>
      </mtg-dropdown>

      <mtg-dropdown
        *ngIf="selectedTournament && selectedTournament.settings.type === tournamentTypes.fiba"
        label="Этап"
        formControlName="tournamentStageId"
        [errorVisible]="false"
      >
        <mtg-dropdown-item [value]="null">Все этапы</mtg-dropdown-item>
        <mtg-dropdown-item
          [value]="stage.id"
          *ngFor="let stage of stages"
        >{{ stage.name }}</mtg-dropdown-item>
      </mtg-dropdown>

      <mtg-dropdown
        *ngIf="selectedTournament"
        label="Команда"
        formControlName="teamId"
        [errorVisible]="false"
      >
        <mtg-dropdown-item [value]="null">Все команды</mtg-dropdown-item>
        <mtg-dropdown-item
          *ngFor="let team of teams"
          [value]="team.team.id"
        >{{ team.team.name }}</mtg-dropdown-item>
      </mtg-dropdown>
    </div>
  </div>
</div>
